import { colors, typography } from '../../styles/theme';

const BORDER = '#383838';
const TEXT_PRIMARY = '#F9FAFB';
const TEXT_MUTED = 'rgba(255,255,255,0.45)';

export const appearanceTextColors = {
  border: BORDER,
  primary: TEXT_PRIMARY,
  muted: TEXT_MUTED,
};

export const appearanceSelectSx = {
  width: '100%',
  minWidth: 0,
  borderRadius: '10px',
  fontSize: '13px',
  fontFamily: typography.fontFamily.primary,
  color: TEXT_PRIMARY,
  bgcolor: colors.backgroundDark,
  '& .MuiOutlinedInput-notchedOutline': { borderColor: BORDER },
  '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(255,255,255,0.28)' },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: colors.primary },
  '& .MuiSelect-icon': { color: TEXT_MUTED },
  '& .MuiSelect-select': {
    py: 1.15,
    px: 1.5,
    pr: '36px !important',
    display: 'flex',
    alignItems: 'center',
    minHeight: '20px',
    overflow: 'hidden',
  },
};

export const appearanceMenuPaperSx = {
  bgcolor: colors.backgroundSurface,
  backgroundImage: 'none',
  border: `1px solid ${colors.border}`,
  maxHeight: 280,
};

export const appearanceMenuItemSx = {
  fontFamily: typography.fontFamily.primary,
  fontSize: '13px',
  color: TEXT_PRIMARY,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 1,
  minHeight: 40,
  '&:hover': { bgcolor: 'rgba(255,255,255,0.08)' },
  '&.Mui-selected': { bgcolor: 'rgba(255,255,255,0.10)' },
  '&.Mui-selected:hover': { bgcolor: 'rgba(255,255,255,0.14)' },
};
